import { TagsProps } from '@lightbeamai/design-system'

export enum UserRole {
  PLATFORM_VIEWER = 'platform-viewer',
  PLATFORM_OWNER = 'platform-owner',
  ADMIN = 'platform-admin',
  DATASOURCE_OWNER = 'datasource-admin',
  DATASOURCE_VIEWER = 'datasource-viewer',
  DATA_STEWARD = 'data-steward',
  USER = 'user'
}

export enum PermissionModules {
  DATASOURCE = 'datasource',
  DASHBOARD = 'dashboard',
  ALERTS_AUDIT_LOGS = 'alerts-audit-logs',
  OBJECT_VIEWER = 'object-viewer',
  ALERTS = 'alerts',
  PRIVACY_OPS = 'privacy-ops',
  USER_ADDITION = 'user-addition',
  DELETION_ARCHIVAL_FILES = 'delete-archive-file',
  ROPA_PIA_PROCESSES = 'ropa-pia-process',
  ROPA_PIA_TEMPLATES = 'ropa-pia-template',
  ROPA_PIA_TICKETS = 'ropa-pia-ticket',
  ROPA_PIA_REPORTS = 'ropa-pia-report',
  ROPA_PIA_REVIEWS = 'ropa-pia-review',
  PRIVACY_OPS_DSR = 'privacy-ops-dsr',
  PRIVACY_OPS_COOKIE_CONSENT = 'privacy-ops-cookie-consent',
  PRIVACY_OPS_CONSENT_MANAGEMENT = 'privacy-ops-consent-management',
  POLICIES = 'policies-and-ruleset',
  SUB_ALERTS = 'sub-alert-management',
  ATTRIBUTES = 'attributes',
  LABELS = 'labels',
  TEMPLATES = 'templates',
  REPORT_SETTINGS = 'report-settings',
  USER_MANAGEMENT = 'user-management',
  ROLE_MANAGEMENT = 'role-management',
  AUTH_PROVIDER = 'auth-provider-settings',
  SMTP_SETTINGS = 'smtp-settings',
  RISK_SCORE_SETTINGS = 'risk-score-settings',
  GOVERNANCE = 'governance',
  OBJECTS = 'objects',
  DOCUMENTS = 'documents',
  USER_ENTITY = 'user-entity'
}

export const PermissionModulesLabelMapper = {
  [PermissionModules.DATASOURCE]: 'settings.roles.permission.module.datasource',
  [PermissionModules.DASHBOARD]: 'settings.roles.permission.module.dashboard',
  [PermissionModules.ALERTS_AUDIT_LOGS]: 'settings.roles.permission.module.alerts-audit-logs',
  [PermissionModules.OBJECT_VIEWER]: 'settings.roles.permission.module.object-viewer',
  [PermissionModules.PRIVACY_OPS]: 'settings.roles.permission.module.privacy-ops',
  [PermissionModules.USER_ADDITION]: 'settings.roles.permission.module.user-addition',
  [PermissionModules.DELETION_ARCHIVAL_FILES]:
    'settings.roles.permission.module.deletion-archival-files',
  [PermissionModules.ROPA_PIA_PROCESSES]: 'settings.roles.permission.module.privacyOps.process',
  [PermissionModules.ROPA_PIA_TEMPLATES]: 'settings.roles.permission.module.privacyOps.template',
  [PermissionModules.ROPA_PIA_TICKETS]: 'settings.roles.permission.module.privacyOps.ticket',
  [PermissionModules.ROPA_PIA_REPORTS]: 'settings.roles.permission.module.privacyOps.report',
  [PermissionModules.ROPA_PIA_REVIEWS]: 'settings.roles.permission.module.privacyOps.review',
  [PermissionModules.PRIVACY_OPS_COOKIE_CONSENT]:
    'settings.roles.permission.module.privacyOps.cookieConsent',
  [PermissionModules.PRIVACY_OPS_CONSENT_MANAGEMENT]:
    'settings.roles.permission.module.privacyOps.consentManagement',
  [PermissionModules.PRIVACY_OPS_DSR]: 'settings.roles.permission.module.privacyOps.dsr',
  [PermissionModules.POLICIES]: 'settings.roles.permission.module.privacyOps.policies',
  [PermissionModules.ALERTS]: 'settings.roles.permission.module.privacyOps.alerts',
  [PermissionModules.SUB_ALERTS]: 'settings.roles.permission.module.privacyOps.subAlerts',
  [PermissionModules.ATTRIBUTES]: 'settings.roles.permission.module.privacyOps.attributes',
  [PermissionModules.LABELS]: 'settings.roles.permission.module.privacyOps.labels',
  [PermissionModules.TEMPLATES]: 'settings.roles.permission.module.privacyOps.template',
  [PermissionModules.REPORT_SETTINGS]:
    'settings.roles.permission.module.administration.reportSettings',
  [PermissionModules.USER_MANAGEMENT]:
    'settings.roles.permission.module.administration.userManagement',
  [PermissionModules.ROLE_MANAGEMENT]:
    'settings.roles.permission.module.administration.roleManagement',
  [PermissionModules.AUTH_PROVIDER]: 'settings.roles.permission.module.administration.authProvider',
  [PermissionModules.SMTP_SETTINGS]: 'settings.roles.permission.module.administration.smtpSettings',
  [PermissionModules.RISK_SCORE_SETTINGS]:
    'settings.roles.permission.module.administration.riskScoreSettings',
  [PermissionModules.GOVERNANCE]: 'settings.roles.permission.module.governance',
  [PermissionModules.OBJECTS]: 'settings.roles.permission.module.objects',
  [PermissionModules.DOCUMENTS]: 'settings.roles.permission.module.documents',
  [PermissionModules.USER_ENTITY]: 'settings.roles.permission.module.user-entity'
}

export enum AccessLevelOptions {
  NO_ACCESS = 'no',
  FULL_ACCESS = 'full',
  LIMITED_ACCESS = 'limited',
  READ_ONLY = 'read-only',
  ASSIGNED_ONLY = 'assigned-only'
}

export const AccessLevelOptionsLabelMapper = {
  [AccessLevelOptions.NO_ACCESS]: 'settings.roles.permissions.noAccess',
  [AccessLevelOptions.FULL_ACCESS]: 'settings.roles.permissions.fullAccess',
  [AccessLevelOptions.LIMITED_ACCESS]: 'settings.roles.permissions.limitedAccess',
  [AccessLevelOptions.READ_ONLY]: 'settings.roles.permissions.readOnly',
  [AccessLevelOptions.ASSIGNED_ONLY]: 'settings.roles.permissions.assignedOnly',

  [`${PermissionModules.ROPA_PIA_PROCESSES}-${AccessLevelOptions.FULL_ACCESS}`]: 'settings.roles.permissions.ropaPia.process.fullAccess',
  [`${PermissionModules.ROPA_PIA_PROCESSES}-${AccessLevelOptions.LIMITED_ACCESS}`]: 'settings.roles.permissions.ropaPia.process.limitedAccess',
  [`${PermissionModules.ROPA_PIA_PROCESSES}-${AccessLevelOptions.NO_ACCESS}`]: 'settings.roles.permissions.noAccess',

  [`${PermissionModules.ROPA_PIA_TEMPLATES}-${AccessLevelOptions.FULL_ACCESS}`]: 'settings.roles.permissions.ropaPia.template.fullAccess',
  [`${PermissionModules.ROPA_PIA_TEMPLATES}-${AccessLevelOptions.LIMITED_ACCESS}`]: 'settings.roles.permissions.ropaPia.template.limitedAccess',
  [`${PermissionModules.ROPA_PIA_TEMPLATES}-${AccessLevelOptions.NO_ACCESS}`]: 'settings.roles.permissions.noAccess',

  [`${PermissionModules.ROPA_PIA_REVIEWS}-${AccessLevelOptions.LIMITED_ACCESS}`]: 'settings.roles.permissions.ropaPia.review.limitedAccess',
  [`${PermissionModules.ROPA_PIA_REVIEWS}-${AccessLevelOptions.NO_ACCESS}`]: 'settings.roles.permissions.noAccess',

  [`${PermissionModules.ROPA_PIA_REPORTS}-${AccessLevelOptions.FULL_ACCESS}`]: 'settings.roles.permissions.ropaPia.report.fullAccess',
  [`${PermissionModules.ROPA_PIA_REPORTS}-${AccessLevelOptions.LIMITED_ACCESS}`]: 'settings.roles.permissions.ropaPia.report.limitedAccess',
  [`${PermissionModules.ROPA_PIA_REPORTS}-${AccessLevelOptions.NO_ACCESS}`]: 'settings.roles.permissions.noAccess',

  [`${PermissionModules.ROPA_PIA_TICKETS}-${AccessLevelOptions.LIMITED_ACCESS}`]: 'settings.roles.permissions.ropaPia.ticket.limitedAccess',
  [`${PermissionModules.ROPA_PIA_TICKETS}-${AccessLevelOptions.NO_ACCESS}`]: 'settings.roles.permissions.noAccess'
}

export const AccessLevelOptionsTooltipMapper = {
  [`${PermissionModules.ROPA_PIA_PROCESSES}-${AccessLevelOptions.FULL_ACCESS}`]: 'settings.roles.permissions.ropaPia.process.fullAccess.tooltip',
  [`${PermissionModules.ROPA_PIA_PROCESSES}-${AccessLevelOptions.LIMITED_ACCESS}`]: 'settings.roles.permissions.ropaPia.process.limitedAccess.tooltip',

  [`${PermissionModules.ROPA_PIA_TEMPLATES}-${AccessLevelOptions.FULL_ACCESS}`]: 'settings.roles.permissions.ropaPia.template.fullAccess.tooltip',
  [`${PermissionModules.ROPA_PIA_TEMPLATES}-${AccessLevelOptions.LIMITED_ACCESS}`]: 'settings.roles.permissions.ropaPia.template.limitedAccess.tooltip',

  [`${PermissionModules.ROPA_PIA_REVIEWS}-${AccessLevelOptions.LIMITED_ACCESS}`]: 'settings.roles.permissions.ropaPia.review.limitedAccess.tooltip',

  [`${PermissionModules.ROPA_PIA_REPORTS}-${AccessLevelOptions.FULL_ACCESS}`]: 'settings.roles.permissions.ropaPia.report.fullAccess.tooltip',
  [`${PermissionModules.ROPA_PIA_REPORTS}-${AccessLevelOptions.LIMITED_ACCESS}`]: 'settings.roles.permissions.ropaPia.report.limitedAccess.tooltip',

  [`${PermissionModules.ALERTS}-${AccessLevelOptions.LIMITED_ACCESS}`]: 'settings.roles.permissions.alerts.limitedAccess.tooltip',
  [`${PermissionModules.ALERTS_AUDIT_LOGS}-${AccessLevelOptions.LIMITED_ACCESS}`]: 'settings.roles.permissions.alertsAuditLogs.limitedAccess.tooltip',
  [`${PermissionModules.ROPA_PIA_TICKETS}-${AccessLevelOptions.LIMITED_ACCESS}`]: 'settings.roles.permissions.ropaPia.ticket.limitedAccess.tooltip'
}

export enum RoleScopes {
  GLOBAL = 'global',
  DATASOURCE = 'datasource',
  ALERTS = 'alert',
  CUSTOM = 'custom'
}

export const RoleScopesColor: Record<RoleScopes, TagsProps['color']> = {
  [RoleScopes.GLOBAL]: 'lavender',
  [RoleScopes.DATASOURCE]: 'palatinate',
  [RoleScopes.ALERTS]: 'information',
  [RoleScopes.CUSTOM]: 'cream'
}

export enum PermissionGroup {
  GLOBAL = 'global',
  PRIVACY_OPS = 'privacy-ops',
  POLICIES = 'policies-and-alerts',
  INSIGHTS = 'insights',
  ADMINISTRATION = 'administration'
}

export enum PermissionType {
  RADIO = 'radio',
  CHECKBOX = 'checkbox'
}

export enum PermissionActionValues {
  STATE_CHANGES = 'state-changes',
  ASSIGN_REASSIGN = 'assign-reassign',
  COMMENT = 'comment',
  RESOLVE = 'resolve',
  ARCHIVE = 'archive',
  DELETE = 'delete',
  REVOKE = 'revoke-access'
}

export type PermissionAction = {
  value: PermissionActionValues
  label: string
}

export interface IPermission {
  permissionName: PermissionModules
  allowPermissionUpdate: boolean
  showPermission: boolean
  permissionGroup: PermissionGroup
  currentAccessLevel?: AccessLevelOptions
  accessOptions?: AccessLevelOptions[]
  type?: PermissionType
  availableActions?: PermissionAction[]
  currentActions?: PermissionActionValues[]
}

export interface IRoleDetails {
  id?: string
  name?: UserRole
  scope?: RoleScopes
  displayName?: string
  description?: string
  assignedUsersCount?: string
  permissions?: IPermission[]
}

export const DEFAULT_PERMISSIONS: IPermission[] = [
  {
    permissionName: PermissionModules.OBJECT_VIEWER,
    showPermission: true,
    allowPermissionUpdate: true,
    permissionGroup: PermissionGroup.GLOBAL,
    type: PermissionType.RADIO,
    accessOptions: [AccessLevelOptions.FULL_ACCESS, AccessLevelOptions.NO_ACCESS],
    currentAccessLevel: AccessLevelOptions.FULL_ACCESS
  },
  {
    permissionName: PermissionModules.POLICIES,
    showPermission: true,
    allowPermissionUpdate: true,
    permissionGroup: PermissionGroup.POLICIES,
    type: PermissionType.RADIO,
    accessOptions: [
      AccessLevelOptions.FULL_ACCESS,
      AccessLevelOptions.READ_ONLY,
      AccessLevelOptions.NO_ACCESS
    ],
    currentAccessLevel: AccessLevelOptions.FULL_ACCESS
  },
  {
    permissionName: PermissionModules.ALERTS,
    showPermission: true,
    allowPermissionUpdate: true,
    permissionGroup: PermissionGroup.POLICIES,
    type: PermissionType.RADIO,
    accessOptions: [
      AccessLevelOptions.FULL_ACCESS,
      AccessLevelOptions.LIMITED_ACCESS,
      AccessLevelOptions.READ_ONLY,
      AccessLevelOptions.NO_ACCESS
    ],
    currentAccessLevel: AccessLevelOptions.FULL_ACCESS
  },
  {
    permissionName: PermissionModules.ALERTS_AUDIT_LOGS,
    showPermission: true,
    allowPermissionUpdate: true,
    permissionGroup: PermissionGroup.POLICIES,
    type: PermissionType.RADIO,
    accessOptions: [
      AccessLevelOptions.FULL_ACCESS,
      AccessLevelOptions.LIMITED_ACCESS,
      AccessLevelOptions.NO_ACCESS
    ],
    currentAccessLevel: AccessLevelOptions.FULL_ACCESS
  },
  {
    permissionName: PermissionModules.SUB_ALERTS,
    showPermission: true,
    allowPermissionUpdate: true,
    permissionGroup: PermissionGroup.POLICIES,
    type: PermissionType.CHECKBOX,
    availableActions: [
      { value: PermissionActionValues.STATE_CHANGES, label: 'State Changes' },
      { value: PermissionActionValues.ASSIGN_REASSIGN, label: 'Assign Reassign' },
      { value: PermissionActionValues.COMMENT, label: 'Comment' },
      { value: PermissionActionValues.RESOLVE, label: 'Resolve' },
      { value: PermissionActionValues.ARCHIVE, label: 'Archive' },
      { value: PermissionActionValues.DELETE, label: 'Delete' },
      { value: PermissionActionValues.REVOKE, label: 'Revoke Access' }
    ],
    currentActions: [
      PermissionActionValues.STATE_CHANGES,
      PermissionActionValues.ASSIGN_REASSIGN,
      PermissionActionValues.COMMENT,
      PermissionActionValues.RESOLVE,
      PermissionActionValues.ARCHIVE,
      PermissionActionValues.DELETE,
      PermissionActionValues.REVOKE
    ]
  },
  {
    permissionName: PermissionModules.ATTRIBUTES,
    showPermission: true,
    allowPermissionUpdate: true,
    permissionGroup: PermissionGroup.INSIGHTS,
    type: PermissionType.RADIO,
    accessOptions: [
      AccessLevelOptions.FULL_ACCESS,
      AccessLevelOptions.READ_ONLY,
      AccessLevelOptions.NO_ACCESS
    ],
    currentAccessLevel: AccessLevelOptions.FULL_ACCESS
  },
  {
    permissionName: PermissionModules.LABELS,
    showPermission: true,
    allowPermissionUpdate: true,
    permissionGroup: PermissionGroup.INSIGHTS,
    type: PermissionType.RADIO,
    accessOptions: [
      AccessLevelOptions.FULL_ACCESS,
      AccessLevelOptions.READ_ONLY,
      AccessLevelOptions.NO_ACCESS
    ],
    currentAccessLevel: AccessLevelOptions.FULL_ACCESS
  },
  {
    permissionName: PermissionModules.TEMPLATES,
    showPermission: true,
    allowPermissionUpdate: true,
    permissionGroup: PermissionGroup.INSIGHTS,
    type: PermissionType.RADIO,
    accessOptions: [
      AccessLevelOptions.FULL_ACCESS,
      AccessLevelOptions.READ_ONLY,
      AccessLevelOptions.NO_ACCESS
    ],
    currentAccessLevel: AccessLevelOptions.FULL_ACCESS
  },
  {
    permissionName: PermissionModules.USER_ENTITY,
    showPermission: true,
    allowPermissionUpdate: true,
    permissionGroup: PermissionGroup.INSIGHTS,
    type: PermissionType.RADIO,
    accessOptions: [
      AccessLevelOptions.FULL_ACCESS,
      AccessLevelOptions.READ_ONLY,
      AccessLevelOptions.NO_ACCESS
    ],
    currentAccessLevel: AccessLevelOptions.FULL_ACCESS
  },
  {
    permissionName: PermissionModules.OBJECTS,
    showPermission: true,
    allowPermissionUpdate: true,
    permissionGroup: PermissionGroup.INSIGHTS,
    type: PermissionType.RADIO,
    accessOptions: [
      AccessLevelOptions.FULL_ACCESS,
      AccessLevelOptions.READ_ONLY,
      AccessLevelOptions.NO_ACCESS
    ],
    currentAccessLevel: AccessLevelOptions.FULL_ACCESS
  },
  {
    permissionName: PermissionModules.DOCUMENTS,
    showPermission: true,
    allowPermissionUpdate: true,
    permissionGroup: PermissionGroup.INSIGHTS,
    type: PermissionType.RADIO,
    accessOptions: [
      AccessLevelOptions.FULL_ACCESS,
      AccessLevelOptions.READ_ONLY,
      AccessLevelOptions.NO_ACCESS
    ],
    currentAccessLevel: AccessLevelOptions.FULL_ACCESS
  },
  {
    permissionName: PermissionModules.ROPA_PIA_PROCESSES,
    showPermission: true,
    allowPermissionUpdate: true,
    permissionGroup: PermissionGroup.PRIVACY_OPS,
    type: PermissionType.RADIO,
    accessOptions: [
      AccessLevelOptions.FULL_ACCESS,
      AccessLevelOptions.LIMITED_ACCESS,
      AccessLevelOptions.NO_ACCESS
    ],
    currentAccessLevel: AccessLevelOptions.FULL_ACCESS
  },
  {
    permissionName: PermissionModules.ROPA_PIA_REPORTS,
    showPermission: true,
    allowPermissionUpdate: true,
    permissionGroup: PermissionGroup.PRIVACY_OPS,
    type: PermissionType.RADIO,
    accessOptions: [
      AccessLevelOptions.FULL_ACCESS,
      AccessLevelOptions.LIMITED_ACCESS,
      AccessLevelOptions.NO_ACCESS
    ],
    currentAccessLevel: AccessLevelOptions.FULL_ACCESS
  },
  {
    permissionName: PermissionModules.ROPA_PIA_REVIEWS,
    showPermission: true,
    allowPermissionUpdate: true,
    permissionGroup: PermissionGroup.PRIVACY_OPS,
    type: PermissionType.RADIO,
    accessOptions: [AccessLevelOptions.LIMITED_ACCESS, AccessLevelOptions.NO_ACCESS],
    currentAccessLevel: AccessLevelOptions.LIMITED_ACCESS
  },
  {
    permissionName: PermissionModules.ROPA_PIA_TICKETS,
    showPermission: true,
    allowPermissionUpdate: true,
    permissionGroup: PermissionGroup.PRIVACY_OPS,
    type: PermissionType.RADIO,
    accessOptions: [AccessLevelOptions.LIMITED_ACCESS, AccessLevelOptions.NO_ACCESS],
    currentAccessLevel: AccessLevelOptions.LIMITED_ACCESS
  },
  {
    permissionName: PermissionModules.ROPA_PIA_TEMPLATES,
    showPermission: true,
    allowPermissionUpdate: true,
    permissionGroup: PermissionGroup.PRIVACY_OPS,
    type: PermissionType.RADIO,
    accessOptions: [
      AccessLevelOptions.FULL_ACCESS,
      AccessLevelOptions.LIMITED_ACCESS,
      AccessLevelOptions.NO_ACCESS
    ],
    currentAccessLevel: AccessLevelOptions.FULL_ACCESS
  },
  {
    permissionName: PermissionModules.PRIVACY_OPS_DSR,
    showPermission: true,
    allowPermissionUpdate: true,
    permissionGroup: PermissionGroup.PRIVACY_OPS,
    type: PermissionType.RADIO,
    accessOptions: [AccessLevelOptions.FULL_ACCESS, AccessLevelOptions.NO_ACCESS],
    currentAccessLevel: AccessLevelOptions.FULL_ACCESS
  },
  {
    permissionName: PermissionModules.PRIVACY_OPS_CONSENT_MANAGEMENT,
    showPermission: true,
    allowPermissionUpdate: true,
    permissionGroup: PermissionGroup.PRIVACY_OPS,
    type: PermissionType.RADIO,
    accessOptions: [AccessLevelOptions.FULL_ACCESS, AccessLevelOptions.NO_ACCESS],
    currentAccessLevel: AccessLevelOptions.FULL_ACCESS
  },
  {
    permissionName: PermissionModules.PRIVACY_OPS_COOKIE_CONSENT,
    showPermission: true,
    allowPermissionUpdate: true,
    permissionGroup: PermissionGroup.PRIVACY_OPS,
    type: PermissionType.RADIO,
    accessOptions: [AccessLevelOptions.FULL_ACCESS, AccessLevelOptions.NO_ACCESS],
    currentAccessLevel: AccessLevelOptions.FULL_ACCESS
  },
  {
    permissionName: PermissionModules.REPORT_SETTINGS,
    showPermission: true,
    allowPermissionUpdate: true,
    permissionGroup: PermissionGroup.ADMINISTRATION,
    type: PermissionType.RADIO,
    accessOptions: [AccessLevelOptions.FULL_ACCESS, AccessLevelOptions.NO_ACCESS],
    currentAccessLevel: AccessLevelOptions.FULL_ACCESS
  },
  {
    permissionName: PermissionModules.RISK_SCORE_SETTINGS,
    showPermission: true,
    allowPermissionUpdate: true,
    permissionGroup: PermissionGroup.ADMINISTRATION,
    type: PermissionType.RADIO,
    accessOptions: [AccessLevelOptions.FULL_ACCESS, AccessLevelOptions.NO_ACCESS],
    currentAccessLevel: AccessLevelOptions.FULL_ACCESS
  },
  {
    permissionName: PermissionModules.AUTH_PROVIDER,
    showPermission: true,
    allowPermissionUpdate: true,
    permissionGroup: PermissionGroup.ADMINISTRATION,
    type: PermissionType.RADIO,
    accessOptions: [AccessLevelOptions.FULL_ACCESS, AccessLevelOptions.NO_ACCESS],
    currentAccessLevel: AccessLevelOptions.FULL_ACCESS
  },
  {
    permissionName: PermissionModules.SMTP_SETTINGS,
    showPermission: true,
    allowPermissionUpdate: true,
    permissionGroup: PermissionGroup.ADMINISTRATION,
    type: PermissionType.RADIO,
    accessOptions: [AccessLevelOptions.FULL_ACCESS, AccessLevelOptions.NO_ACCESS],
    currentAccessLevel: AccessLevelOptions.FULL_ACCESS
  },
  {
    permissionName: PermissionModules.USER_MANAGEMENT,
    showPermission: true,
    allowPermissionUpdate: true,
    permissionGroup: PermissionGroup.ADMINISTRATION,
    type: PermissionType.RADIO,
    accessOptions: [AccessLevelOptions.FULL_ACCESS, AccessLevelOptions.NO_ACCESS],
    currentAccessLevel: AccessLevelOptions.FULL_ACCESS
  },
  {
    permissionName: PermissionModules.ROLE_MANAGEMENT,
    showPermission: true,
    allowPermissionUpdate: true,
    permissionGroup: PermissionGroup.ADMINISTRATION,
    type: PermissionType.RADIO,
    accessOptions: [
      AccessLevelOptions.FULL_ACCESS,
      AccessLevelOptions.READ_ONLY,
      AccessLevelOptions.NO_ACCESS
    ],
    currentAccessLevel: AccessLevelOptions.FULL_ACCESS
  },
  {
    permissionName: PermissionModules.DASHBOARD,
    showPermission: true,
    allowPermissionUpdate: true,
    permissionGroup: PermissionGroup.ADMINISTRATION,
    type: PermissionType.RADIO,
    accessOptions: [
      AccessLevelOptions.FULL_ACCESS,
      AccessLevelOptions.READ_ONLY,
      AccessLevelOptions.NO_ACCESS
    ],
    currentAccessLevel: AccessLevelOptions.FULL_ACCESS
  },
  {
    permissionName: PermissionModules.GOVERNANCE,
    showPermission: true,
    allowPermissionUpdate: true,
    permissionGroup: PermissionGroup.ADMINISTRATION,
    type: PermissionType.RADIO,
    accessOptions: [
      AccessLevelOptions.FULL_ACCESS,
      AccessLevelOptions.READ_ONLY,
      AccessLevelOptions.NO_ACCESS
    ],
    currentAccessLevel: AccessLevelOptions.FULL_ACCESS
  },
  {
    permissionName: PermissionModules.DATASOURCE,
    showPermission: true,
    allowPermissionUpdate: true,
    permissionGroup: PermissionGroup.ADMINISTRATION,
    type: PermissionType.RADIO,
    accessOptions: [
      AccessLevelOptions.FULL_ACCESS,
      AccessLevelOptions.READ_ONLY,
      AccessLevelOptions.NO_ACCESS
    ],
    currentAccessLevel: AccessLevelOptions.FULL_ACCESS
  }
]

export const AccessActionsLabelMapper = {
  [PermissionActionValues.STATE_CHANGES]: 'settings.roles.actions.stateChanges',
  [PermissionActionValues.ASSIGN_REASSIGN]: 'settings.roles.actions.assignReassign',
  [PermissionActionValues.COMMENT]: 'settings.roles.actions.comment',
  [PermissionActionValues.RESOLVE]: 'settings.roles.actions.resolve',
  [PermissionActionValues.ARCHIVE]: 'settings.roles.actions.archive',
  [PermissionActionValues.DELETE]: 'settings.roles.actions.delete',
  [PermissionActionValues.REVOKE]: 'settings.roles.actions.revoke'
}
